import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import {environment} from './environments/environment';
import {enableProdMode} from '@angular/core';


if (environment.disableLog) {
  enableProdMode();
  console.log =  () => {
    // Don't log anything.
  };
}
bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
